import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';
import api from './api/index'

const app = createApp(App);

app.config.globalProperties.$api = api;

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token');
    if(to.meta.auth) {
        if (!token) {
            next('/login');
        } else {
            next();
        }
    } else {
        next();
    }
});

app.use(store);
app.use(router);
app.use(ElementPlus);

app.mount('#app')
